import { ContratoService } from './../../../services/contrato/contrato.service';
import { VisitasarrendatarioService } from './../../../services/visita/visitasarrendatario.service';
import { Component, OnInit } from '@angular/core';
declare function inicializarPluginsSidebar();

@Component({
  selector: 'app-dasharrendatario',
  templateUrl: './dasharrendatario.component.html',
  styleUrls: ['./dasharrendatario.component.css']
})
export class DasharrendatarioComponent implements OnInit {

  solicitudVisitas = 0;
  contratosArrendatario = 0;

  constructor( public _serviceVisita: VisitasarrendatarioService, public _contratoService: ContratoService,) { }

  ngOnInit(): void {
    inicializarPluginsSidebar();
    this.cargarVisitas();
    this.cargarContratos();
  }

  cargarVisitas() {
    this._serviceVisita.cargarVisitasArrendatario(0)
      .subscribe(total => {
        this.solicitudVisitas = this._serviceVisita.totalSolicitudVisitas;
      });
  }

  cargarContratos() {
    this._contratoService.cargarContratosArrendatario(0)
      .subscribe(contratos => { this.contratosArrendatario = this._contratoService.totalContratos });
  }
}
